import React from 'react';
import type { Collection } from '@airhead-games/shared/content';
import BlockRenderer from '@/content/rendering/renderers/BlockRenderer';
import RichTextRenderer from '@/content/rendering/renderers/RichTextRenderer';
import WidgetRenderer from '@/content/rendering/renderers/WidgetRenderer';

interface CollectionSectionListProps {
  sections: Collection['sections'];
}

const CollectionSectionList: React.FC<CollectionSectionListProps> = ({
  sections,
}) => (
  <div className="flex flex-col gap-10">
    {sections.map((section) => (
      <section
        key={section.id}
        id={section.id}
        className="flex flex-col gap-6 border-t border-border pt-8 first:border-t-0 first:pt-0"
      >
        {section.title && (
          <div className="flex w-full flex-col gap-3">
            <h2 className="font-heading text-2xl leading-tight font-semibold tracking-tight md:text-3xl xl:text-4xl">
              <RichTextRenderer nodes={section.title} />
            </h2>
            {section.description && (
              <p className="w-full text-base leading-6 text-muted-foreground sm:leading-7">
                <RichTextRenderer nodes={section.description} />
              </p>
            )}
          </div>
        )}
        <BlockRenderer blocks={section.blocks} />
        <WidgetRenderer widgets={section.widgets} />
      </section>
    ))}
  </div>
);

export default CollectionSectionList;
